module.exports = __webpack_public_path__ + "img/emptyWorkExp.98afbae5.png";